import store from "@/store/store";
import router from "@/router";
import loginApi from "@/services/loginApi";

export default ({
    state: {
        tenantGuid: "",
        propertyGuid: "",
        authToken : "",
        jwtAuthenticationToken: "",
        tokenExpirationDate: ""
    },
    actions:{
        Logout({commit}){
            commit("SET_LOGGED_OUT")
        },
        AutoLogin({commit}){
            let localJWT = sessionStorage.getItem("jwtToken")
            if (localJWT !== undefined && localJWT !== "") {
                let expireDateString =  sessionStorage.getItem("tokenExpirationDate")
                let nowDate = Date.now()
                const authExpireDate = new Date(expireDateString)
                //Allow auto login for 5 minute from when the auth token expired or force the user to log in again.
                let fiveMinGrace = new Date(authExpireDate);
                fiveMinGrace.setMinutes(authExpireDate.getMinutes() + 5);

                if( nowDate >=fiveMinGrace.getTime() ){
                    commit("SET_LOGGED_OUT")
                }else {

                    loginApi.login().then(response => {
                        commit("SET_JWT_AUTHENTICATION", response.data)
                        store.dispatch("loadPropertyInfo")
                        store.dispatch("loadPropertyConfigurationInfo")
                         // Go to previous route
                        router.go(-1)
                    }).catch()
                }
            }
        },
        RefreshAuthToken({commit}){
            let localJWT = sessionStorage.getItem("jwtToken")
            if (localJWT !== undefined && localJWT !== "") {
                let expireDateString =  sessionStorage.getItem("tokenExpirationDate")
                let nowDate = Date.now()
                const authExpireDate = new Date(expireDateString)
                //Allow auto login for 5 minute from when the auth token expired or force the user to log in again.
                let fiveMinGrace = new Date(authExpireDate);
                fiveMinGrace.setMinutes(authExpireDate.getMinutes() + 5);

                if( nowDate >=fiveMinGrace.getTime() ){
                    commit("SET_LOGGED_OUT")
                }else if(nowDate >= authExpireDate.getTime()) {
                    loginApi.login().then(response => {
                        commit("SET_JWT_AUTHENTICATION", response.data)
                        return Promise.resolve(true);
                    })
                }
            }
        },
        AuthenticateToApi({ commit }) {
            loginApi.login().then(response => {
                commit("SET_JWT_AUTHENTICATION", response.data)
                store.dispatch("loadPropertyInfo")
                store.dispatch("loadPropertyConfigurationInfo")
                store.dispatch("loadAnnouncements")
                router.push('/portal/')
            })
        },
        Unauthorized({commit}){
            commit("UNAUTHORIZED")
        }

    },
    mutations: {
        SET_PROPERTY_GUID(state, value) {
            let localPropertyGuid = sessionStorage.getItem("propertyGuid")
            if ((value === undefined || value === null) && localPropertyGuid !== undefined) {
                state.propertyGuid = localPropertyGuid
            } else {
                state.propertyGuid = value;
                sessionStorage.setItem("propertyGuid", value)
            }
        },
        SET_TENANT_AUTH_TOKEN(state, value) {
            let localAuthToken = sessionStorage.getItem("authToken")
            if ((value === undefined || value === null) && localAuthToken !== undefined) {
                state.authToken = localAuthToken
            } else {
                state.authToken = value;
                sessionStorage.setItem("authToken", value)
            }
        },
        SET_JWT_AUTHENTICATION(state, data, useLocalStore) {
            if(useLocalStore){
                state.jwtAuthenticationToken =  sessionStorage.getItem("jwtToken");
                state.tokenExpirationDate =  sessionStorage.getItem("tokenExpirationDate");
                state.tenantGuid = sessionStorage.getItem("tenantGuid")
            }else{
                state.jwtAuthenticationToken = data.token;
                state.tokenExpirationDate = data.expireDateTime;
                state.tenantGuid = data.unitGuid
                sessionStorage.setItem("tenantGuid", data.unitGuid)
                sessionStorage.setItem("jwtToken", data.token)
                sessionStorage.setItem("tokenExpirationDate", data.expireDateTime)
            }
        },

        SET_LOGGED_OUT(state) {
            state.jwtAuthenticationToken = "";
            state.tokenExpirationDate = "";
            state.tenantGuid = "";

            sessionStorage.setItem("jwtToken", "")
            sessionStorage.setItem("tenantGuid", "")
            sessionStorage.setItem("tokenExpirationDate", "")
        },
        UNAUTHORIZED(state){
            state.jwtAuthenticationToken = "";
            state.tokenExpirationDate = "";
            state.tenantGuid = "";
            state.tokenExpirationDate = "";
            state.jwtAuthenticationToken = "";
            sessionStorage.clear();
        }
    },
    getters: {
        getTenantGuid(state) { return state.tenantGuid; },
        getPropertyGuid(state) {  return state.propertyGuid; },
        getTenantAuthToken(state) {  return state.authToken; },
        getJwtAuthenticationToken(state){return state.jwtAuthenticationToken},
        getIsLoggedIn(state){
            return !(state.jwtAuthenticationToken === undefined || state.jwtAuthenticationToken === "");
        },
        getTokenExpiration(state){return state.tokenExpirationDate}
    }
})
